import { gql } from '@apollo/client'
import { BodyText, Heading } from '@farol-ds/react'

import { LawsuitTwoOfferPlanCard } from '../../lawsuit-two-offer-plan-card'
import {
  LawsuitTwoOffersLockContent_OfferLockDataFragment,
  LawsuitTwoOffersLockContent_ViewerFragment,
} from './__generated__/lawsuit-two-offers-lock-content.graphql'
import styles from './lawsuit-two-offers-lock-content.module.scss'

export interface LawsuitTwoOffersLockContentProps {
  offerLockData: LawsuitTwoOffersLockContent_OfferLockDataFragment
  viewer: LawsuitTwoOffersLockContent_ViewerFragment
}

export function LawsuitTwoOffersLockContent({
  offerLockData,
  viewer,
}: LawsuitTwoOffersLockContentProps) {
  const header = offerLockData.header
  const { title = '', subtitle = '' } = header
  const { body } = offerLockData || {}
  const { cards } = body || {}

  return (
    <div>
      <Heading className={styles.lawsuitTwoOffersLockTitle} size="lg" asChild>
        <h3>{title}</h3>
      </Heading>
      <BodyText size="md" className={styles.lawsuitTwoOffersLockSubtitle}>
        <span dangerouslySetInnerHTML={{ __html: subtitle }} />
      </BodyText>
      <div className={styles.lawsuitTwoOffersLockCards}>
        {cards.map((card, index) => (
          <LawsuitTwoOfferPlanCard
            offerLockBody={body}
            offerLockCard={card}
            viewer={viewer}
            key={`lawsuit-two-offer-plan-card-${index}`}
            className={styles.lawsuitTwoOffersLockCardsCard}
          />
        ))}
      </div>
    </div>
  )
}

LawsuitTwoOffersLockContent.fragments = {
  offerLockData: gql`
    fragment LawsuitTwoOffersLockContent_offerLockData on OfferLockData {
      header {
        title
        subtitle
      }
      body {
        ...LawsuitTwoOfferPlanCard_offerLockBody
        cards {
          ...LawsuitTwoOfferPlanCard_offerLockCard
        }
      }
    }
    ${LawsuitTwoOfferPlanCard.fragments.offerLockCard}
    ${LawsuitTwoOfferPlanCard.fragments.offerLockBody}
  `,
  viewer: gql`
    fragment LawsuitTwoOffersLockContent_viewer on Profile {
      ...LawsuitTwoOfferPlanCard_viewer
    }
    ${LawsuitTwoOfferPlanCard.fragments.viewer}
  `,
}
